import * as React from 'react';
import { Attribute } from '../../product';
import { MultiSelect } from './MultiSelect';
import Select from './Select';
import { Text } from './Text';

const VariantOptions: string[] = ['Grind Size', 'Gift Wrapping', 'Size'];

const arrToOpts = (opts: string[]) =>
  opts.map((val: string) => ({
    label: val,
    value: val,
  }));

interface Props {
  attribute: Attribute;
  setAttribute: Function;
  onDelete: Function;
}

const setValue = (props: Props) => (key: string, value: string) => {
  const item = Object.assign({}, props.attribute, {
    [key]: value,
  });

  props.setAttribute(item);
};

export default function VariantAttributesListItem(props: Props) {
  const [isEditing, setIsEditing] = React.useState(false);

  if (!isEditing) {
    return (
      <div className="pv3 bt b--black-10 db black flex items-center">
        <div className="w-30-ns mr3-ns">{props.attribute.name}</div>
        <div className="w-50-ns ml3-ns black-70">
          {props.attribute.options.join(', ')}
        </div>
        <div className="w-20-ns ml3-ns tr">
          <button
            type="button"
            className="gold b dib link bg-transparent bw0 pointer dim ma0 pa1 pa3-ns w3"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mb2 db black flex items-center">
      <div className="w-30-ns mr3-ns">
        <div className="mr3 flex-auto">
          <Select
            label="Name"
            field={['name']}
            id={'name'}
            defaultValue={props.attribute.name}
            onValueChange={setValue(props)}
            options={arrToOpts(VariantOptions.concat(['Other…']))}
          />
          {!VariantOptions.includes(props.attribute.name) &&
          props.attribute.name ? (
            <Text
              label="Enter a value…"
              field={['name']}
              id={'custom-name'}
              defaultValue={props.attribute.name}
              onValueChange={setValue(props)}
              placeholder="Name i.e. 'Gift Wrapping'"
            />
          ) : null}
        </div>
      </div>
      <div className="flex-auto ml3-ns">
        <MultiSelect
          label="Options"
          field={['options']}
          id="options"
          defaultValue={props.attribute.options}
          onValueChange={setValue(props)}
        />
      </div>
      <button
        type="button"
        className="red b dib link bg-transparent bw0 pointer dim ma0 pa1 pa3-ns w3"
        onClick={() => props.onDelete()}
      >
        ✕
      </button>
    </div>
  );
}
